import { env } from "@oefr/env/client"
import { type PartnerKey } from "../types/partnerKey"

export const Partner = {
    Darty: "darty",
    DartyOctopus: "darty-octopus",
    Effy: "effy",
} as const

export type Partner = (typeof Partner)[keyof typeof Partner]

export const DOMAIN_PARTNER_MAP: Record<string, PartnerKey> = {
    localhost: "default",
    "octopusenergy.fr": "default",
    [env.NEXT_PUBLIC_DARTY_HOST]: "darty",
}
